export default {
  buttons: {
    save: 'Speichern',
  },
  error_messages: {
    product_unavailable: 'Ausverkauft!',
  },
};
